import React from 'react';
import '../App.css';
import lap from './images/laptop_screen.png';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function About() {
  const { ref, inView } = useInView({  triggerOnce: true , threshold: 0.3 });

  return (
    <>
      <section id='about'>
        <div className="about-section text-light d-flex flex-column">
          <h1 className="gradient-text mt-5 text-center">About</h1>

          <div className="container my-auto">
            <div className="row align-items-center">

              {/* Image Column */}
              <div className="col-12 col-lg-6 text-center mb-4 mb-lg-0">
                <motion.img
                  ref={ref}
                  src={lap}
                  alt="Laptop Screen"
                  className="img-fluid"
                  initial={{ opacity: 0, y: 80 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 1.0, delay: 0.3, ease: 'easeOut' }}
                />
              </div>

              {/* Text Column */}
              <div className="col-12 col-lg-6">
                <motion.div
                  ref={ref}
                  initial={{ opacity: 0, y: 50 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 1.0, delay: 0.3, ease: 'easeOut' }}
                >
                  <p className="gradient-text  mb-4 fs-5">
                    MDQ’s Production Management System is a centralized platform designed to streamline production workflows, monitor real-time operations, manage inventory, track resources, and deliver actionable insights.
                  </p>
                  <p className="gradient-text  fs-5">
                    “From Sales to Dispatch – Manage Every Step with Confidence”
                  </p>
                </motion.div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}
